module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADUSURBVEhL7ZLNCcJAEIVTQKoxRQixCy92pILlJEerUBsQj0L0m81LCEh0Nj94yQfDzmbmvZmFJAtuqqraELeXA+sjckl9ILhK74L+i6Q+pIui0bleFBSRdHU/X6S+KPp0DDsF0y6qRdHVzfoCMyfWwagPGub9ixDk3iFmTnzf+K+wZFbv2nJm45UlnKXahoPJIdgK7jtir7xQ2zDwSDG5m5lB/uBIVR4Phtvauob7UaVpwLCUd0Om0jQw4CnjFhuq8njk+YHK42HbQp4t9k3lhalJkjdV4tJtT7kVmQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-drill/light/24.png
// module id = 2002
// module chunks = 2